const config = {
  apiKey: "AIzaSyBSvEQ_0_KmQclKwSpw4z0IQHZgKhd-09s",
  authDomain: "aerelontech.firebaseapp.com",
  projectId: "aerelontech",
  storageBucket: "aerelontech.firebasestorage.app",
  messagingSenderId: "688590446407",
  appId: "1:688590446407:web:c84d9e9f4087379068b662",
  measurementId: "G-RQJQC5BBX0",
};

export { config };

